module.exports = "/assets/landing-bfw/how-it-works/step_3.png?4urUrhj";